module.exports = {"firstName":null,"lastName":null,"phoneNumber":null,"userEmail":null,"password":null,"optIn":false,"leadSource":null,"leadSourceType":null,"leadSourceManual":null,"campaignUrl":null}


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/registration/model.json
// module id = TzxW
// module chunks = 1